import CameraPlan from "./camera.js";
import ImagePlan from "./image.js";
import TextPlan from "./text.js";
import VideoPlan from "./video.js";
import PlanBase from "./planBase.js";

const creator = function(itemType, data = {}) {
    switch (itemType) {
        case "CameraPlanItem":
            return CameraPlan.fromObject(data);
        case "ImagePlanItem":
            return ImagePlan.fromObject(data);
        case "TextPlanItem":
            return TextPlan.fromObject(data);
        case "VideoPlanItem":
            return VideoPlan.fromObject(data);
        default:
            return PlanBase.fromObject(data);
    }
}

export default creator;